<div class="container single-view" id="view-product-type">
  <div class="row">
    <div class="col-12 mb-4 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/product-types" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'PRODUCT_TYPES.BTN_BACK_TO_PRODUCT_TYPE' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr flex flex-wrap items-center">
          <div data-testid="producttype-item">
            <h1 data-testid="section-item" class="section-title mb-3">{{ 'PRODUCT_TYPE_SINGLE_VIEW.PRODUCT_TYPE_DETAILS' | translate }}</h1>
            <div>
              <h2 data-testid="element-item" class="element-title flex items-center gap-2">
                @if (productType.name) {
                  <span data-testid="producttype-name">{{ productType.name | defaultValue }}</span>
                }
              </h2>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap justify-between gap-y-4 self-end">
          <div id="complementary-details" class="flex flex-wrap"></div>
          <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3">
            @if (allowModifyProductType) {
              <button data-testid='producttype-edit-btn' id="btn-edit-product-type" class="btn primary-btn" (click)="goToEditProductType()">{{ 'PRODUCT_TYPE_SINGLE_VIEW.BTN_EDIT' | translate }}</button>
            }
            @if (delete) {
              <button data-testid='producttype-delete-btn' id="btn-delete-product-type" class="btn red-btn" (click)="showDeleteDialog()">{{'PRODUCT_TYPES.BTN_DELETE' | translate }}</button>
            }
          </div>
        </div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-4 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <section class="row">
              <div class="col-12 col-sm-12 col-md-4 col-lg-3">
                <img data-testid='producttype-imageurl' src="{{ productType.imageUrl }}" class="w-100 mt-2 featured-image">
              </div>
              <div class="col-12 col-sm-12 col-md-8 col-lg-9">
                <h4 data-testid='producttype-details'>{{ 'PRODUCT_TYPE_SINGLE_VIEW.DETAILS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                <dl class="details-grid">

                  <dt data-testid='producttype-name-label' class="label grid-cols-1 pt-3">{{ 'PRODUCT_TYPE_SINGLE_VIEW.NAME' | translate }}</dt>
                  <dd data-testid='producttype-name' class="value pt-3 pb-3">{{ productType.name | defaultValue }}</dd>

                  <dt data-testid='producttype-code-label' class="label grid-cols-1 pt-3">{{ 'PRODUCT_TYPE_SINGLE_VIEW.CODE' | translate }}</dt>
                  <dd data-testid='producttype-code' class="value pt-3 pb-3">{{ productType.code | defaultValue }}</dd>

                  <dt data-testid='producttype-hasparent-label' class="label grid-cols-1 pt-3">{{ 'PRODUCT_TYPE_SINGLE_VIEW.HAS_PARENT' | translate }}</dt>
                  <dd data-testid='producttype-hasparent' class="value pt-3 pb-3">{{ (productType.parent ? 'BOOLEANS.YES' : 'BOOLEANS.NO') | translate }}</dd>

                  @if (productType.parent) {
                    <dt data-testid='producttype-parent-producttype-label' class="label grid-cols-1 pt-3">{{ 'PRODUCT_TYPE_SINGLE_VIEW.PARENT_NAME' | translate }}</dt>
                    <dd class="value pt-3 pb-3">
                      @if (productType.parent.id) {
                        <a  [routerLink]="['/product-types/', productType.parent.id]" data-testid='producttype-parent-producttype' class="inline-flex items-center link">{{ productType.parent.name }}</a>
                      } @else {
                        {{ productType.parent.name | defaultValue }}
                      }
                    </dd>
                    <dt data-testid='producttype-parent-code-lable' class="label grid-cols-1 pt-3">{{ 'PRODUCT_TYPE_SINGLE_VIEW.PARENT_CODE' | translate }}</dt>
                    <dd data-testid='producttype-parent-code' class="value pt-3 pb-3">{{ productType.parent.code | defaultValue }}</dd>
                  }
                </dl>
              </div>
            </section>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete product type -->
<dialog-reason  #dialog [title]="'MODALBOXES.TITLE_CONFIRM_DELETE_PRODUCT_ATTRIBUTES'" (onClose)="deleteProductType($event)"></dialog-reason>
